import { render, staticRenderFns } from "./IndexThresholdSettings.vue?vue&type=template&id=38332950&scoped=true&"
import script from "./IndexThresholdSettings.vue?vue&type=script&lang=js&"
export * from "./IndexThresholdSettings.vue?vue&type=script&lang=js&"
import style0 from "./IndexThresholdSettings.vue?vue&type=style&index=0&id=38332950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38332950",
  null
  
)

/* custom blocks */
import block0 from "./IndexThresholdSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38332950')) {
      api.createRecord('38332950', component.options)
    } else {
      api.reload('38332950', component.options)
    }
    module.hot.accept("./IndexThresholdSettings.vue?vue&type=template&id=38332950&scoped=true&", function () {
      api.rerender('38332950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company-settings/IndexThresholdSettings.vue"
export default component.exports